<template>
  <layouts-header></layouts-header>

  <breadcrumb :title="title" :text="text" :text1="text1" />
  <coach-settings-tabset></coach-settings-tabset>
  <div class="content court-bg">
    <div class="container">
      <settings-tabset></settings-tabset>

      <div class="row">
        <div class="col-sm-12">
          <div class="profile-detail-blk">
            <ul>
              <li>
                <router-link to="/coaches/coach-profile">Profile Details </router-link>
              </li>
              <li>
                <router-link to="/coaches/appointment-details"
                  >Appointment Details</router-link
                >
              </li>
            </ul>
          </div>
          <div class="profile-detail-group">
            <div class="card">
              <form>
                <div class="row">
                  <div class="col-md-12">
                    <div class="file-upload-text">
                      <div class="file-upload">
                        <img
                          src="@/assets/img/icons/img-icon.svg"
                          class="img-fluid"
                          alt="Upload"
                        />
                        <p>Upload Photo</p>
                        <span>
                          <i class="feather-edit-3"></i>
                          <input type="file" id="file-input" />
                        </span>
                      </div>
                      <h5>
                        Upload a logo with a minimum size of 150 * 150 pixels (JPG, PNG,
                        SVG).
                      </h5>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-6">
                    <div class="input-space">
                      <label for="name" class="form-label">Name</label>
                      <input
                        type="text"
                        class="form-control"
                        id="name"
                        placeholder="Enter Name"
                      />
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-6">
                    <div class="input-space">
                      <label for="name" class="form-label">Email</label>
                      <input
                        type="email"
                        class="form-control"
                        id="email"
                        placeholder="Enter Email Address"
                      />
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-6">
                    <div class="input-space">
                      <label for="name" class="form-label">Phone Number</label>
                      <input
                        type="text"
                        class="form-control"
                        id="phone"
                        placeholder="Enter Phone Number"
                      />
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-6">
                    <div class="input-space">
                      <label class="form-label">Select Level</label>
                      <vue-select
                        :options="ExpertLevel"
                        id="expertlevel"
                        placeholder="Expert"
                      />
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-6">
                    <div class="input-space">
                      <label class="form-label">Year Of Experience</label>
                      <vue-select :options="YearNum" id="yearnum" placeholder="5" />
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-6">
                    <div class="input-space">
                      <label class="form-label">Type of Appointments</label>
                      <vue-select
                        :options="TypePro"
                        id="typepro"
                        placeholder="Both Onetime & Lesson Type"
                      />
                    </div>
                  </div>
                  <div class="col-lg-12 col-md-12">
                    <div class="info-about">
                      <label class="form-label">Information about You</label>
                      <textarea
                        class="form-control"
                        id="comments"
                        rows="3"
                        placeholder="About"
                      ></textarea>
                    </div>
                  </div>
                  <div class="address-form-head">
                    <h4>Address</h4>
                  </div>
                  <div class="col-lg-12 col-md-12">
                    <div class="input-space">
                      <label class="form-label">Address</label>
                      <input
                        type="text"
                        class="form-control"
                        id="address"
                        placeholder="Enter Address"
                      />
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-6">
                    <div class="input-space">
                      <label class="form-label">State</label>
                      <input
                        type="text"
                        class="form-control"
                        id="state"
                        placeholder="Enter State"
                      />
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-6">
                    <div class="input-space">
                      <label class="form-label">City</label>
                      <input
                        type="text"
                        class="form-control"
                        id="city"
                        placeholder="Enter City"
                      />
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <div class="input-space">
                      <label class="form-label">Country</label>
                      <vue-select
                        :options="CountryPro"
                        id="countrypro"
                        placeholder="Country"
                      />
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-6">
                    <div class="input-space mb-0">
                      <label class="form-label">Zipcode</label>
                      <input
                        type="text"
                        class="form-control"
                        id="zipcode"
                        placeholder="Enter Zipcode"
                      />
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div class="save-changes text-end">
              <a href="javascript:;" class="btn btn-primary reset-profile">Reset</a>
              <a href="javascript:;" class="btn btn-secondary save-profile"
                >Save Change</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <layout-footer></layout-footer>
</template>
<script>
export default {
  data() {
    return {
      title: "Profile Setting",
      text: "Home",
      text1: "Profile Setting",
      ExpertLevel: ["Expert", "Experience"],
      YearNum: ["5", "4", "3", "2", "1"],
      TypePro: ["Both Onetime & Lesson Type", "Both Onetime", "Lesson Type"],
      CountryPro: ["Country", "Texas"],
    };
  },
};
</script>
